class CustomError extends Error {
	errorData?: any;
	errorMessage?: string;
	errorTarget?: any;

	constructor(errorData?: any, errorMessage?: string, target?: any) {
		super(errorMessage);
		this.errorMessage = errorMessage;
		this.errorData = errorData;
		this.errorTarget = target;
	}

	public toString() {
		if (this.errorData && CustomError.prototype.isPrototypeOf(this.errorData))
			return (this.errorMessage ?? "Couldn't complete action") + ": " + this.errorData.toString();

		if (this.errorData && this.errorData.toString() != "" && this.errorData.toString() != "[object Object]")
			return `${this.errorMessage}: ${this.errorData.toString()}`;

		return (this.errorMessage ?? "Couldn't complete action") + (this.errorData?.message ? `: ${this.errorData.message}` : "");
	}

	public toJson() {
		if (this.errorData && CustomError.prototype.isPrototypeOf(this.errorData))
			return {
				errorMessage: this.errorMessage,
				errorTarget: this.errorTarget,
				errorData: this.errorData.toJson()
			};
		if (this.errorData && Error.prototype.isPrototypeOf(this.errorData))
			return {
				errorMessage: this.errorMessage,
				errorData: {
					errorName: this.errorData.name,
					errorMessage: this.errorData.toString(),
					errorTrace: this.errorData.stack
				}
			};

		
		return {
			errorMessage: this.errorMessage,
			errorData: this.errorData
		};
	}
}

export class TransactionError extends CustomError {
	constructor(errorData: any, errorMessage?: string, target?: any) {
		super(errorData, errorMessage, target);
		this.errorMessage = errorMessage ?? errorData.message ?? "";
	}
}

export class StandardError extends CustomError {
	constructor(errorData: any, errorMessage?: string, target?: any) {
		super(errorData, errorMessage, target);
		this.errorMessage = errorMessage ?? errorData.message ?? "";
	}
}